import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-462ec50e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" 上传图片 ");

var _hoisted_2 = {
  class: "el-upload__tip"
};
var _hoisted_3 = {
  class: "tiptext"
};
var _hoisted_4 = {
  class: "imgPreview"
};
var _hoisted_5 = {
  class: "imgbox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_image = _resolveComponent("el-image");

  var _component_Close = _resolveComponent("Close");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_upload = _resolveComponent("el-upload");

  return _openBlock(), _createBlock(_component_el_upload, {
    class: "upload-demo",
    action: "",
    "file-list": _ctx.fileList,
    "list-type": "picture",
    "show-file-list": false,
    "http-request": _ctx.request,
    accept: _ctx.accept,
    "before-upload": _ctx.beforeAvatarUpload,
    disabled: _ctx.fileList.length == _ctx.limit
  }, {
    tip: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, " *上传图片上限为" + _toDisplayString(_ctx.limit) + "张*", 1)]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: item
        }, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_image, {
          class: "img",
          fit: "cover",
          "preview-src-list": _ctx.srcList,
          "initial-index": index,
          src: _ctx.baseUrl + item
        }, null, 8, ["preview-src-list", "initial-index", "src"]), _createVNode(_component_el_icon, {
          size: 16,
          class: "circle"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_Close, {
              onClick: function onClick($event) {
                return _ctx.handleRemove(index);
              }
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_Close)];
              }),
              _: 2
            }, 1032, ["onClick"])];
          }),
          _: 2
        }, 1024)])]);
      }), 128))])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["file-list", "http-request", "accept", "before-upload", "disabled"]);
}